import { timestamp } from '../utils';
import { Timestamp } from '../messages';
export default class Socket {
    constructor(onMessage, onUnexpectedClose) {
        this.onMessage = onMessage;
        this.onUnexpectedClose = onUnexpectedClose;
        this.conn = null;
        this.buffer = [new Uint8Array(1), new Uint8Array(0)];
    }
    connect(url) {
        if (this.conn === null) {
            this.conn = new WebSocket(url);
            this.conn.binaryType = 'arraybuffer';
            this.conn.onmessage = (e) => this.onMessage(new Uint8Array(e.data));
            this.conn.onclose = () => {
                this.buffer.length = 2;
                this.buffer[0][0] = 0;
                if (this.conn !== null) {
                    this.conn = null;
                    this.onUnexpectedClose();
                }
            };
            this.conn.onerror = () => this.close();
        }
    }
    commit() {
        if (this.conn === null ||
            this.conn.readyState !== WebSocket.OPEN ||
            this.buffer.length === 2) {
            return;
        }
        this.buffer[1] = Timestamp(timestamp());
        const lengths = this.buffer.map((b) => b.length);
        const data = new Uint8Array(lengths.reduce((l, s) => l + s, 0));
        for (let i = 0, p = 0; i < this.buffer.length; i++) {
            data.set(this.buffer[i], p);
            p += lengths[i];
        }
        this.conn.send(data);
        this.buffer.length = 2;
        this.buffer[0][0]++;
    }
    push(data) {
        if (this.conn !== null) {
            this.buffer.push(data);
        }
    }
    close() {
        if (this.conn !== null) {
            this.conn.close();
            this.conn = null;
        }
    }
}
